module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "result"
    }
  }, [(_vm.show) ? _c('div', {
    class: {
      isAuthor: _vm.isAuthor, isViewer: !_vm.isAuthor
    },
    attrs: {
      "id": "result"
    }
  }, [(_vm.isAuthor === true) ? _c('button', {
    staticClass: "replay",
    on: {
      "click": _vm.toReplay
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('replay-icon', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('result.btn_again')))])], 1)]) : _vm._e(), _c('div', {
    staticClass: "top"
  }, [_c('swoosh-icon', {
    staticClass: "swoosh head"
  }), _c('h2', {
    staticClass: "title"
  }, [(_vm.isAuthor === true) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('result.title')))])]) : _vm._e(), (_vm.isAuthor === false) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('share.generic.title')[0]))]), _c('p', [_vm._v(_vm._s(_vm.$t('share.generic.title')[1]))])]) : _vm._e()]), _c('finish-time', {
    attrs: {
      "time": _vm.duration
    }
  }), (_vm.isAuthor === true) ? _c('div', {
    staticClass: "percentile"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.percentile[0]')))]), _c('span', {
    staticClass: "big"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("assets/result/btn-blue.png")
    }
  }), _c('reveal-text', {
    attrs: {
      "text": _vm.percentile,
      "reveal": _vm.revealed
    }
  }), _c('span', {
    staticClass: "percent"
  }, [_vm._v("%")])], 1), _c('span', [_vm._v(_vm._s(_vm.$t('result.percentile[1]')))])]) : _vm._e(), (_vm.isAuthor === true) ? _c('div', {
    staticClass: "label share-content"
  }, [_vm._v(_vm._s(_vm.$t('result.share_content')))]) : _vm._e()], 1), _c('div', {
    staticClass: "hero"
  }), _c('div', {
    staticClass: "bottom"
  }, [(_vm.isAuthor === false) ? _c('h2', {
    staticClass: "cta-copy"
  }, [_vm._v(_vm._s(_vm.$t('share.generic.subtitle')))]) : _vm._e(), (_vm.isAuthor === true) ? _c('div', {
    staticClass: "buttons buttons-two"
  }, [(_vm.locale !== 'en') ? _c('button', {
    staticClass: "draw",
    on: {
      "click": _vm.toDraw
    }
  }, [_c('div', {
    staticClass: "bg"
  }), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.btn_draw')))])])]) : _vm._e(), _c('button', {
    staticClass: "buy",
    on: {
      "click": _vm.toBuy
    }
  }, [_c('div', {
    staticClass: "bg"
  }), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.btn_buy')))])])])]) : _c('div', {
    staticClass: "buttons buttons-one"
  }, [_c('button', {
    staticClass: "home",
    on: {
      "click": _vm.toHome
    }
  }, [_c('div', {
    staticClass: "bg"
  }), _c('div', {
    staticClass: "content"
  }, [(_vm.username) ? _c('span', [_vm._v(_vm._s(_vm.$t('share.named.cta')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('share.generic.cta')))])])])]), (_vm.isAuthor === true && _vm.locale !== 'en') ? _c('div', {
    staticClass: "tc-button",
    on: {
      "click": _vm.toTc
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('span', [_vm._v("i")])]), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('result.btn_tc')))])])]) : _vm._e()]), _c('tc', {
    attrs: {
      "active": _vm.showTc
    },
    on: {
      "close": function($event) {
        _vm.showTc = false
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2f75040"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/result/Result.vue
// module id = 460
// module chunks = 1